import * as React from 'react';
import { Col, Row, Divider, Input, Select, Checkbox, Tabs } from 'antd';

import Form, { FormItem, ColorInput } from '../../../components/Form';
import { Title } from '../../../components/Layout/components';
import { getWatchDogActions } from 'helpers/src/availability/watchDogActions';
import GetCurrenciesQuery from '../../../components/Query/Currencies';
import { AVAILABILITIES } from 'helpers/src/schema.org/ItemAvailability';

interface IAvailabilityDetailProps {
  domain: string;
  availability: GQL.IAvailability;
  languages: Array<GQL.ILanguage>;
  onSave: (availability: GQL.IAvailability) => void;
  onCancel: () => void;
}

interface IAvailabilityDetailState {
  availability: GQL.IAvailability;
  currentLanguage: string;
}

export default class AvailabilityDetail extends React.Component<IAvailabilityDetailProps, IAvailabilityDetailState> {

  public constructor(props: IAvailabilityDetailProps) {
    super(props);

    this.state = {
      availability: props.availability || {},
      currentLanguage: props.languages.map(l => l.value)[0],
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { languages } = this.props;
    const { availability, currentLanguage } = this.state;
    const { allowedActions } = availability;
    const watchDogActionsRaw = getWatchDogActions();
    const watchDogActions = Object.keys(watchDogActionsRaw).filter(key => watchDogActionsRaw.hasOwnProperty(key)).map((key) => ({key, label: watchDogActionsRaw[key]}));

    return (
      <div>
        <Title
          languages={languages}
          currentLanguage={this.state.currentLanguage}
          onChange={(l: string) => { this.setState({ currentLanguage: l }); }}
        >
          {availability
            ? `Availability ${availability.name ? `"${availability.name}"` : ''}`
            : `Availabilities`}
        </Title>

        <Divider />
        <Form
          onSubmit={this.save}
          onCancel={this.props.onCancel}
        >
          <Row>
            <Col md={24}>
              <FormItem label={'Title'} required={true}>
                <Input
                  name={'name'}
                  autoFocus={true}
                  required={true}
                  placeholder="Internal title. For example &quot;Skladem&quot;"
                  addonBefore={'Internal'}
                  defaultValue={availability.name || ''}
                  onChange={e => this.onChange(e)}
                />
              </FormItem>
              <FormItem label={'Name'} required={true}>
                <Input
                  key={currentLanguage}
                  name={'title'}
                  required={true}
                  addonBefore={currentLanguage}
                  placeholder="Availability's name in eshop"
                  defaultValue={(availability.title || {})[currentLanguage]}
                  onChange={e => this.onChange(e, currentLanguage)}
                />
              </FormItem>
              <FormItem label={'Color'} extra={'Internal color highlighting availability status for backoffice'}>
                <ColorInput
                  name={'color'}
                  value={availability.color || ''}
                  onChange={e => this.onChange(e)}
                />
              </FormItem>
              <FormItem>
                <Checkbox
                  name={'default'}
                  checked={availability.default !== null ? availability.default : false}
                  onChange={e => this.onChange(e)}
                >
                  Default
                </Checkbox>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col md={24}>
              <FormItem label="schema.org availabilty for LD+JSON">
                <Select
                  defaultValue={availability.schemaOrg || undefined}
                  allowClear={true}
                  onChange={(v) => this.onChange({target: {name: 'schemaOrg', value: v}})}>
                  {AVAILABILITIES.map((availability) => {return <Select.Option key={availability} value={availability}>{availability}</Select.Option>;})}
                </Select>
              </FormItem>
            </Col> 
          </Row>
          <Row>
            <Col md={24}>
              <FormItem label="Watchdog action">
                <Select
                  defaultValue={availability.watchDogAction || undefined}
                  allowClear={true}
                  onChange={(v) => this.onChange({target: {name: 'watchDogAction', value: v}})}>
                  {watchDogActions.map((type) => {return <Select.Option key={type.key} value={type.key}>{type.label}</Select.Option>;})}
                </Select>
              </FormItem>
            </Col> 
          </Row>
          <GetCurrenciesQuery>
            {({ currencies, loading  }: any) => {
              if (loading || !Array.isArray(currencies.currencies)) {
                return null;
              }
              return (
              <Tabs defaultActiveKey="0" onChange={() => {}}>
                {currencies.currencies.map((cur: GQL.ICurrency, index: number) => (
                  <Tabs.TabPane tab={cur.value} key={String(index)}>
                    <FormItem label={'Enable selling'}>
                      <Checkbox 
                        checked={allowedActions && allowedActions[cur.value] && allowedActions[cur.value]['sell']}
                        onChange={(e) => this.onChangeAllowedActions(cur.value, 'sell', !!e.target.checked)}
                      />
                    </FormItem>
                    <FormItem label={'Enable watchdog'}> 
                      <Checkbox
                        checked={allowedActions && allowedActions[cur.value] &&allowedActions[cur.value]['watchdog']}
                        onChange={(e) => this.onChangeAllowedActions(cur.value, 'watchdog', !!e.target.checked)}
                      />
                    </FormItem>
                  </Tabs.TabPane>
                ))}
              </Tabs>);

            }}
          </GetCurrenciesQuery>
          <Divider />
          <FormItem>
            <Checkbox
              name={'excludeFromSitemap'}
              checked={availability.excludeFromSitemap || false}
              onChange={e => this.onChange(e)}
            >
              Exclude from sitemap
            </Checkbox>
          </FormItem>
        </Form>
      </div>
    );
  }

  private onChangeAllowedActions(language: string, type: string, state: boolean) {
    const { availability } = this.state;
    let { allowedActions } = availability;

    if (!allowedActions) {
      allowedActions = {};
    }

    if(!allowedActions[language]) {
      allowedActions[language] = {};
    }

    allowedActions[language][type] = state;

    this.setState({
      availability: { ...availability, allowedActions }
    });
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);
    const newValue = (language
      ? { [name]: { ...this.state.availability[name], [language]: inputValue } }
      : { [name]: inputValue });
    this.setState({
      availability: { ...this.state.availability, ...newValue }
    });
  }

  private async save() {
    const availability = { ...this.state.availability };
    this.props.onSave(availability);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Availabilities/AvailabilityDetail/AvailabilityDetail.tsx